import { Api } from 'lib/api'
import { IResponse } from 'lib/types/response'

export const streamerAuthorize = (requestUrl: string) => {
  return Api
    .get<IResponse<{src: Location}>>(requestUrl)
    .then(res => res.src)
}
